import React, { Component } from 'react';
import { generate } from 'shortid';

import PlaceAutocompleteSearchBox from '../PlaceAutocomplete/SearchBox';
import { AddressValidation } from '../../tools/Validations';

const autocompleteOptions = {
  types: ["(cities)"],
  componentRestrictions: {
    country: ["ca", "us"],
  }
};

class AddressField extends Component {
  constructor(props) {
    super(props);
    this.id = generate();
    this.validation = props.validation || new AddressValidation();
    this.validation.test(props.value);
  }

  render() {
    const { value } = this.props;
    return (
      <PlaceAutocompleteSearchBox
        id={this.id}
        name="address"
        type="text"
        label="City, Province/State, Country"
        onChange={this.onChange}
        value={value}
        validationState={this.validation.getState()}
        help="Passcode currently only support Canada and the US"
        placeholder="e.g. Vancouver, BC, Canada"
        options={autocompleteOptions} />
    );
  }

  onChange = (e, isValid = false) => {
    const { value } = e.target;
    if (!value) {
      this.validation.reset();
    }

    let addressIsValid = isValid && this.validation.test(value);
    let onChange = this.props.onChange;
    if (onChange) {
      onChange(e, addressIsValid);
    }
  }
}

export default AddressField;



// WEBPACK FOOTER //
// ./src/components/FieldGroup/AddressField.js